import { api } from './api';

export const fetchTransactions = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/transaction', params, options);
};

export const fetchTransactionById = (id) => {
  return api.get(`/transaction/${id}`);
};
